<template>
    <div class="page">
        <yd-timeline>
            <yd-timeline-item v-for="vo in ver">
                <h1 style="font-size:2em;">{{vo.title}}</h1>
                <p>{{vo.time}}</p>
                <p></p>
                <ul class="info">
                    <li v-for="info in vo.desc">{{info}}</li>
                </ul>
                <p v-if="vo.download" class="download">
                    <a :href="vo.download.win32" v-if="vo.download.win32"><yd-icon name="download" size=".3rem"></yd-icon> Windows 32 位下载</a>
                    <a :href="vo.download.win64" v-if="vo.download.win64"><yd-icon name="download" size=".3rem"></yd-icon> Windows 64 位下载</a>
                    <a :href="vo.download.mac" v-if="vo.download.mac"><yd-icon name="download" size=".3rem"></yd-icon> Mac 下载</a>
                </p>
            </yd-timeline-item>
        </yd-timeline>
    </div>
</template>

<script>
    export default {
        name: "YYStudio",
        data(){
            return {
                ver:[
                    {
                        title:'有影制作器 V1.0.1',
                        time:'2020-04-01',
                        desc:[
                            '制作器经典好用版发布',
                            '优化整体性能',
                            '加入打标功能（打个标标，后期处理）',
                            '老板要求发新榜本',
                            '反正就是这版很好用',
                        ],
                        download: {
                            // win32:'',
                            win64:'https://cdn-yp.yymedias.com/YYStudio/有影制作器 Setup 1.0.1.exe',
                            mac:'javascript:alert("询问客服获取");'
                        }
                    },
                    {
                        title:'有影制作器 V1.0.0',
                        time:'2019-10-16',
                        desc:[
                            '制作器正式版本发布',
                            '修改若干BUG。',
                        ],
                        download: {
                            // win32:'',
                            // win64:'https://cdn-yp.yymedias.com/YYStudio/有影制作器 Setup 1.0.0.exe',
                            // mac:''
                        }
                    },
                ]
            }
        }
    }
</script>

<style scoped>
    .page {
        margin:0 auto; max-width:1000px; min-width:500px;
    }
    .page a {
        color:#3579f6; margin:0 15px;
    }
    .page .info li {
        margin-top:10px;
        list-style-type: circle;
    }
    .page p {
        margin-top:10px;
    }
    .download {padding-top:20px;}
</style>